module.exports = __webpack_public_path__ + "public/SiteIcons/learnIcon.svg?774e2727";